import PropTypes from 'prop-types';
import './MonthPicker.scss';
import 'primeicons/primeicons.css';
import { Menu, MenuItem } from '@mui/material';
import { useRef, useState } from 'react';

const months = [
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
  'January',
  'February',
  'March',
];

const MonthPicker = ({
  visible,
  onVisibleChange,
  value,
  onChange,
  inputClassName,
  containerClassName,
  disabled,
  formatMonths = (arr) => arr,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [loadAll, setLoadAll] = useState(false);
  const inputRef = useRef(null);
  const handleClick = (event) => {
    if (disabled) return;
    setAnchorEl(event.currentTarget);
    onVisibleChange((prev) => !prev);
  };
  const handleClose = () => {
    setLoadAll(false);
    setAnchorEl(null);
    onVisibleChange(false);
  };
  return (
    <div className={containerClassName}>
      <input
        type="text"
        value={value}
        readOnly
        onChange={onChange}
        className={inputClassName + ' month-picker-input'}
        onClick={handleClick}
        ref={inputRef}
        style={{cursor: disabled ? 'not-allowed' : 'pointer'}}
      />
      <button
        className="calendar-dropdown-icon"
        onClick={() => inputRef.current.click()}
      >
        <i className="pi pi-angle-down"></i>
      </button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={visible}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        disableScrollLock={true}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{
          '& .MuiPaper-root': {
            width: '200px',
            maxHeight: '300px',
          },
          '& .MuiMenuItem-root': {
            fontSize: '16px',
          },
        }}
      >
        {formatMonths(months)
          .slice(0, loadAll ? undefined : 5)
          .map((month) => {
            return (
              <MenuItem
                key={month}
                id={`${month}-select`}
                onClick={() => {
                  setLoadAll(false);
                  onChange(month);
                  handleClose();
                }}
              >
                {month}
              </MenuItem>
            );
          })}
        {!loadAll && (
          <MenuItem
            onClick={() => setLoadAll(true)}
            sx={{ color: '#6B5CE8 !important', marginLeft: '-4px', fontSize: '14px !important' }}
          >
            Load more
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};

MonthPicker.propTypes = {
  visible: PropTypes.bool.isRequired,
  onVisibleChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  inputClassName: PropTypes.string.isRequired,
  containerClassName: PropTypes.string,
  disabled: PropTypes.bool,
  formatMonths: PropTypes.func,
};

export default MonthPicker;
